import {useState} from 'react'
import dayjs from 'dayjs'
import Popover from '@mui/material/Popover'
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider'
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs'
import {DateCalendar} from '@mui/x-date-pickers/DateCalendar'
import {StyledDateDiv, StyledEndDateTextField} from './UserManagementStyle'
import {PickersDay} from '@mui/x-date-pickers/PickersDay'
import PropTypes from 'prop-types'

const StartDatePickerComponent = ({startDate, setStartDate, endDate, isProjectCompleted, loading}) => {
  const minDate = dayjs().startOf('day')
  const allowedMaxDate = endDate ? dayjs(endDate).subtract(1, 'day') : null
  const [anchorEl, setAnchorEl] = useState(null)

  const [isPoperOpen, setIsPoperOpen] = useState(false)
  const handleStartDateChange = (date) => {
    if (dayjs(date).isValid()) {
      setStartDate(dayjs(date).format())
    }
    handleClose()
  }

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget)
    setIsPoperOpen(true)
  }

  const handleClose = () => {
    setAnchorEl(null)
    setIsPoperOpen(false)
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      handleOpen(event)
    }
  }
  const calendarStartDate = startDate && dayjs(startDate).isValid() ? dayjs(startDate) : minDate
  // This is to display the date in MM/DD/YYYY format in UI
  const formattedStartDate = startDate ? dayjs(startDate).format('MM/DD/YYYY') : ''

  return (
    <>
      <StyledDateDiv
        type='button'
        onKeyDown={handleKeyDown}
        onClick={handleOpen}
        id='start-date'
        aria-expanded={isPoperOpen}
      >
        <StyledEndDateTextField
          label='Access Start date'
          variant='outlined'
          fullWidth
          placeholder='Access Start date'
          inputProps={{'aria-labelledby': 'start-date'}}
          value={formattedStartDate}
          InputProps={{
            readOnly: true
          }}
          InputLabelProps={{shrink: true}}
          disabled={!isProjectCompleted || loading}
        />
      </StyledDateDiv>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DateCalendar
            value={calendarStartDate}
            onChange={handleStartDateChange}
            minDate={minDate}
            maxDate={allowedMaxDate}
            views={['year', 'day']}
            referenceDate={startDate ? dayjs(startDate) : minDate}
            renderDay={(day, DayComponentProps) => <PickersDay {...DayComponentProps}>{day.getDate()}</PickersDay>}
          />
        </LocalizationProvider>
      </Popover>
    </>
  )
}

StartDatePickerComponent.propTypes = {
  startDate: PropTypes.instanceOf(Date),
  setStartDate: PropTypes.func.isRequired,
  endDate: PropTypes.instanceOf(Date),
  isProjectCompleted: PropTypes.bool.isRequired,
  loading: PropTypes.bool
}

export default StartDatePickerComponent
